import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaAvaliacoesLayer from "../components/ListaAvaliacoesLayer";
import { useTranslation } from "../i18n/I18nContext";

const AvaliacoesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("avaliacao.breadcrumb.list")} />
      <ListaAvaliacoesLayer />
    </MasterLayout>
  );
};

export default AvaliacoesPage;
